import React, { useState, useContext, useEffect } from "react";
import "../styles/Checkout.css";

import pickupLocation from "../img/gardenia-front.webp";
import { CartContext } from "../components/CartContext";
import "../styles/checkoutsidebar.css";
import { Link } from "react-router-dom";
import { submitOrder } from "../services/orderservice";
import visa from "../img/visa.png";
import masterCard from "../img/mastercard-logo-png-transparent.png";
import paynet from "../img/logopaynet.webp";
// import { useNavigate } from "react-router-dom"; // Keep this commented if not used
/* global fbq */ // <-- ADD THIS LINE

const Checkout = () => {
  // const navigate = useNavigate(); // Keep this commented if not used
  // const { clearCart } = useContext(CartContext); // Keep this commented if not used
  const { cartItems, total, clearCart } = useContext(CartContext); // Destructure clearCart here as it's used in handlePlaceOrder

  const cities = [
    { name: "Chișinău", value: "0", price: 100 },
    { name: "Durlesti, mun. Chișinău", value: "1", price: 150 },
    { name: "Codru, mun. Chișinău", value: "2", price: 150 },
    { name: "Cricova, mun. Chișinău", value: "3", price: 200 },
    { name: "Singera, mun. Chișinău", value: "4", price: 200 },
    { name: "Vadul lui Voda, mun. Chișinău", value: "5", price: 200 },
    { name: "Vatra, mun. Chișinău", value: "6", price: 200 },
    { name: "com. Trușeni, mun. Chișinău", value: "7", price: 200 },
    { name: "com. Băcioi, mun. Chișinău", value: "8", price: 200 },
    { name: "com. Stăuceni, mun. Chișinău", value: "9", price: 200 },
    { name: "com. Bubuieci  , mun. Chișinău", value: "10", price: 200 },
    { name: "com. Grătiești, mun. Chișinău", value: "11", price: 200 },
    { name: "com. Ciorescu, mun. Chișinău", value: "12", price: 200 },
    { name: "Ghidighici, mun. Chișinău", value: "13", price: 200 },
    { name: "com. Budești, mun. Chișinău", value: "14", price: 200 },
    { name: "Colonița, mun. Chișinău", value: "15", price: 200 },
    { name: "com. Tohatin, mun. Chișinău", value: "16", price: 200 },
    { name: "com. Cruzești, mun. Chișinău", value: "17", price: 200 },
    { name: "Condrița, mun. Chișinău", value: "18", price: 250 },
    { name: "Anenii Noi", value: "19", price: 450 },
    { name: "Basarabeasca", value: "20", price: 800 },
    { name: "Bălți", value: "21", price: 1100 },
    { name: "Briceni", value: "22", price: 2000 },
    { name: "Cahul", value: "23", price: 1200 },
    { name: "Cantemir", value: "24", price: 950 },
    { name: "Călărași", value: "25", price: 350 },
    { name: "Căușeni", value: "26", price: 600 },
    { name: "Cimișlia", value: "27", price: 600 },
    { name: "Criuleni", value: "28", price: 300 },
    { name: "Dondușeni", value: "29", price: 1800 },
    { name: "Drochia", value: "30", price: 1500 },
    { name: "Dubăsari", value: "31", price: 380 },
    { name: "Edineț", value: "32", price: 1800 },
    { name: "Fălești", value: "33", price: 900 },
    { name: "Florești", value: "34", price: 1150 },
    { name: "Glodeni", value: "35", price: 1500 },
    { name: "Hîncești", value: "36", price: 300 },
    { name: "Ialoveni", value: "37", price: 200 },
    { name: "Leova", value: "38", price: 700 },
    { name: "Nisporeni", value: "39", price: 550 },
    { name: "Ocnița", value: "40", price: 2000 },
    { name: "Orhei", value: "41", price: 450 },
    { name: "Rezina", value: "42", price: 800 },
    { name: "Rîșcani", value: "43", price: 1500 },
    { name: "Sîngerei", value: "44", price: 800 },
    { name: "Soroca", value: "45", price: 1300 },
    { name: "Strășeni", value: "46", price: 250 },
    { name: "Șoldănești", value: "47", price: 850 },
    { name: "Ștefan Vodă", value: "48", price: 800 },
    { name: "Taraclia", value: "49", price: 1000 },
    { name: "Telenești", value: "50", price: 700 },
    { name: "Ungheni", value: "51", price: 800 },
  ];

  const [recipientData, setRecipientData] = useState({
    name: "",
    phone: "",
    address: "",
  });

  const generateOrderNumber = () => {
    return Math.floor(1000 + Math.random() * 9000).toString();
  };

  const [isPickupSelected, setIsPickupSelected] = useState(false);
  const [showDeliveryAddress, setShowDeliveryAddress] = useState(true);
  const [euSuntDestinatarul, setEuSuntDestinatarul] = useState(false);
  const [isCardSelected, setIsCardSelected] = useState(true); // Default to card selected
  // const { cartItems, total } = useContext(CartContext); // Removed this duplicate destructuring
  const [selectedCity, setSelectedCity] = useState(cities[0]);
  const [formErrors, setFormErrors] = useState({});
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [showTermsWarning, setShowTermsWarning] = useState(false);
  const [deliveryDateValidationError, setDeliveryDateValidationError] =
    useState("");
  const [showRecipientAddress, setShowRecipientAddress] = useState(true);

  const [isProcessing, setIsProcessing] = useState(false);
  // Add sender data state
  const [senderData, setSenderData] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
  });

  const styles = {
    error: {
      color: "red",
      fontSize: "12px",
      marginTop: "0",
      marginLeft: "8px",
    },
    errorInput: {
      border: "1px solid red",
    },
  };

  const getApiUrl = () => {
    return process.env.REACT_APP_API_URL || "https://api.gardeniaflowers.md";
  };

  const handleRecipientChange = (e) => {
    const { name, value } = e.target;
    setRecipientData((prev) => ({
      ...prev,
      [name]: value,
    }));

    const error = validateField(
      `recipient${name.charAt(0).toUpperCase() + name.slice(1)}`,
      value
    );
    setFormErrors((prev) => ({
      ...prev,
      [`recipient${name.charAt(0).toUpperCase() + name.slice(1)}`]: error,
    }));
  };

  const handleSenderChange = (e) => {
    const { name, value } = e.target;
    setSenderData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate this specific field
    const error = validateField(
      `sender${name.charAt(0).toUpperCase() + name.slice(1)}`,
      value
    );

    setFormErrors((prev) => ({
      ...prev,
      [`sender${name.charAt(0).toUpperCase() + name.slice(1)}`]: error,
    }));
  };

  const reshakeErrorMessages = () => {
    const errorElements = document.querySelectorAll(".error-message");

    errorElements.forEach((element) => {
      element.classList.remove("error-message");
      void element.offsetWidth;
      element.classList.add("error-message");
    });
  };

  const handlePlaceOrder = async (e) => {
    e.preventDefault();

    if (deliveryDateValidationError) {
      reshakeErrorMessages();
      const cityErrorElement = document.querySelector(
        ".delivery-city-box .error-message"
      );
      if (cityErrorElement) {
        window.scrollTo({
          top: cityErrorElement.offsetTop - 150,
          behavior: "smooth",
        });
      }
      return;
    }

    setIsProcessing(true);

    try {
      const validationErrors = {};

      // Validate recipient name (still mandatory)
      if (!isPickupSelected) {
        const recipientNameError = validateField(
          "recipientName",
          recipientData.name
        );
        if (recipientNameError)
          validationErrors.recipientName = recipientNameError;
      }

      // Validate sender fields
      if (!euSuntDestinatarul) {
        const senderNameError = validateField("senderName", senderData.name);
        const senderEmailError = validateField("senderEmail", senderData.email); // Re-added email validation

        if (senderNameError) validationErrors.senderName = senderNameError;
        if (senderEmailError) validationErrors.senderEmail = senderEmailError; // Add email error to validationErrors
      }

      // Validate terms
      if (!isTermsChecked) {
        validationErrors.terms = "Trebuie să acceptați termenii și condițiile";
        setShowTermsWarning(true);
      }

      const orderNumber = generateOrderNumber();

      setFormErrors(validationErrors);
      if (Object.keys(validationErrors).length > 0) {
        setTimeout(() => {
          reshakeErrorMessages();
          const errorElement = document.querySelector(".error-message");
          if (errorElement) {
            window.scrollTo({
              top: errorElement.offsetTop - 150,
              behavior: "smooth",
            });
          }
        }, 100);

        setIsProcessing(false);
        return;
      }

      const orderData = {
        orderNumber,
        recipient: {
          name: recipientData.name,
          phone: recipientData.phone,
          city: selectedCity.name,
          address: showDeliveryAddress ? recipientData.address : "",
          message: document.querySelector("textarea#message")?.value || "",
        },
        sender: {
          name: euSuntDestinatarul ? recipientData.name : senderData.name,
          phone: euSuntDestinatarul ? recipientData.phone : senderData.phone,
          email: senderData.email,
          address: euSuntDestinatarul ? recipientData.address : "",
          isSameAsRecipient: euSuntDestinatarul,
        },
        orderDetails: {
          items: cartItems.map((item) => ({
            id: item.id,
            name: item.name,
            quantity: item.quantity,
            price: item.price,
            image: item.image,
            extras: item.extras,
            greetingText: item.greetingText,
            deliveryDate: item.deliveryDate,
            deliveryTime: item.deliveryTime,
          })),
          subtotal: total,
          deliveryFee: getDeliveryCost(),
          total: calculateFinalTotal(),
        },
        isPickup: isPickupSelected,
        isAnonymous: isAnonymous,
        payment: {
          method: "paynet", // Always paynet now
        },
        paymentDetails: {
          paymentMethod: "PAYNET",
          transactionId: "",
          paynetSignature: "",
        },
        paymentStatus: "PENDING",
      };

      // Handle PayNet payment (always card now)
      try {
        const apiUrl = getApiUrl();
        console.log("Processing card payment through Paynet...");

        const orderResponse = await submitOrder(orderData);

        if (!orderResponse.success) {
          throw new Error(orderResponse.error || "Eroare la crearea comenzii");
        }

        const orderId = orderResponse.order._id;
        console.log("Order created successfully with ID:", orderId);

        const paymentResponse = await fetch(`${apiUrl}/api/process-payment`, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            orderId: orderId,
            paymentMethod: "paynet",
            language: "ro",
          }),
        });

        if (!paymentResponse.ok) {
          throw new Error(
            `Eroare la inițierea plății: ${paymentResponse.status} ${paymentResponse.statusText}`
          );
        }

        const paymentResult = await paymentResponse.json();
        console.log("Payment initiation result:", paymentResult);

        if (!paymentResult.success) {
          throw new Error(paymentResult.error || "Nu s-a putut iniția plata");
        }

        if (paymentResult.form) {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = paymentResult.form;
          tempDiv.style.position = "absolute";
          tempDiv.style.left = "-9999px";
          document.body.appendChild(tempDiv);

          const form = tempDiv.querySelector("form");
          if (form) {
            console.log("Submitting Paynet form...");
            form.submit();
          } else {
            throw new Error("Formular de plată invalid");
          }
        } else if (paymentResult.redirectUrl) {
          window.location.href = paymentResult.redirectUrl;
        } else {
          throw new Error(
            "Nu s-a primit formularul de plată sau URL-ul de redirecționare"
          );
        }
      } catch (error) {
        console.error("Payment error:", error);
        alert("A apărut o eroare la procesarea plății: " + error.message);
        setIsProcessing(false);
        return;
      }
    } catch (error) {
      console.error("Order submission error:", error);
      alert("A apărut o eroare la plasarea comenzii: " + error.message);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCitySelection = (e) => {
    const selectedCityObj = cities[e.target.value];

    const cartItemsWithDeliveryDate = cartItems.filter(
      (item) => item.deliveryDate
    );

    if (cartItemsWithDeliveryDate.length > 0) {
      const item = cartItemsWithDeliveryDate[0];
      const deliveryDate = new Date(item.deliveryDate);

      if (item.deliveryTime) {
        const startHour = parseInt(item.deliveryTime.split("-")[0], 10);
        deliveryDate.setHours(startHour, 0, 0, 0);
      } else {
        deliveryDate.setHours(9, 0, 0, 0);
      }

      const moldovaTime = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Europe/Chisinau" })
      );

      const timeDifferenceMs = deliveryDate.getTime() - moldovaTime.getTime();
      const timeDifferenceHours = timeDifferenceMs / (1000 * 60 * 60);

      if (selectedCityObj.price > 150 && timeDifferenceHours < 24) {
        setDeliveryDateValidationError(
          "Livrarea pe teritoriul Republicii Moldova, cu excepția municipiului Chișinău, trebuie plasată cu minim 24 de ore înainte"
        );

        e.target.value = selectedCity.value;
        return;
      }
    }

    setDeliveryDateValidationError("");
    setSelectedCity(selectedCityObj);
  };

  const isEligibleForFreeDelivery = () => {
    return selectedCity.name === "Chișinău" && total >= 1200;
  };

  const getDeliveryCost = () => {
    if (isPickupSelected) return 0;
    if (isEligibleForFreeDelivery()) return 0;
    return selectedCity?.price || 0;
  };

  const calculateFinalTotal = () => {
    return total + getDeliveryCost();
  };

  // --- START ADDITION FOR INITIATE CHECKOUT (REVISED) ---
  useEffect(() => {
    // Only fire if pixel is loaded, cart has items, and a city is selected (to ensure total is finalized)
    if (window.fbq && cartItems && cartItems.length > 0 && selectedCity) {
      const finalCartTotal = parseFloat(calculateFinalTotal());
      const contentIds = cartItems.map((item) => String(item.id));

      fbq("track", "InitiateCheckout", {
        value: finalCartTotal,
        currency: "MDL",
        num_items: cartItems.length,
        content_ids: contentIds,
        content_type: "product",
      });
      console.log(
        "Meta Pixel: InitiateCheckout event fired. Total:",
        finalCartTotal,
        "Items:",
        contentIds
      ); // For testing
    }
  }, [cartItems, selectedCity, total, calculateFinalTotal]); // Dependencies: cartItems, selectedCity (impacts delivery cost), total (subtotal), calculateFinalTotal (the derived total)
  // Adding `calculateFinalTotal` to dependencies means it will rerun if this *function reference* changes,
  // but more importantly, the values it *depends on* (`selectedCity`, `total`) will trigger it.
  // --- END ADDITION FOR INITIATE CHECKOUT ---
  const validateField = (name, value) => {
    switch (name) {
      case "recipientName":
        return !value?.trim()
          ? "Vă rugăm completați numele destinatarului"
          : "";
      // Recipient phone and address validations are intentionally removed as per previous request.

      case "senderName":
        return !value?.trim() ? "Vă rugăm completați numele expeditorului" : "";

      case "senderEmail": // Re-added email validation logic
        if (!value?.trim()) return "Vă rugăm completați adresa de email";
        if (!/\S+@\S+\.\S+/.test(value)) return "Adresă de email invalidă";
        return "";

      // Sender phone and address validations are intentionally removed as per previous request.
      default:
        return "";
    }
  };

  return (
    <div className="section">
      <h2 className="heading-secondary">Facturare și livrare</h2>
      <div className="grid grid-cols-2">
        <div className="checkout-content">
          <div className="checkout-box">
            <div className="checkout-heading p-4">
              <span>1</span>
              <span>Cine primeste buchetul? (Destinatar)</span>
            </div>

            <div className="checkout-body">
              <div className="same-address ">
                <label className="check">
                  <input
                    type="checkbox"
                    className="hidden check"
                    checked={isPickupSelected}
                    onChange={() => {
                      setIsPickupSelected(!isPickupSelected);
                      if (!isPickupSelected) {
                        setEuSuntDestinatarul(false);
                      }
                    }}
                  />
                  Ridicare de la sediu Chișinău, Petru Rareș 37
                </label>
              </div>

              {!isPickupSelected && (
                <div className="same-address-container-image">
                  <div className="same-address-box space-y-4">
                    <div className="grid-col-checkout">
                      <div className="delivery delivery-name">
                        <input
                          type="text"
                          className={`delivery-input ${
                            formErrors.recipientName ? "error" : ""
                          }`}
                          placeholder="Nume Prenume"
                          name="name"
                          value={recipientData.name}
                          onChange={handleRecipientChange}
                          style={
                            formErrors.recipientName ? styles.errorInput : {}
                          }
                        />
                        <label className="delivery-label">Nume Prenume</label>
                        {formErrors.recipientName && (
                          <div className="error-message" style={styles.error}>
                            {formErrors.recipientName}
                          </div>
                        )}
                      </div>
                      <div className="delivery delivery-phone">
                        <input
                          type="tel"
                          className={`delivery-input ${
                            formErrors.recipientPhone ? "error" : ""
                          }`}
                          placeholder="Telefon"
                          name="phone"
                          value={recipientData.phone}
                          onChange={handleRecipientChange}
                          style={
                            formErrors.recipientPhone ? styles.errorInput : {}
                          }
                        />
                        <label className="delivery-label">Telefon</label>
                        {formErrors.recipientPhone && (
                          <div className="error-message" style={styles.error}>
                            {formErrors.recipientPhone}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="grid-col-checkout">
                      <div className="delivery-city-box">
                        <select
                          className="delivery-city"
                          onChange={handleCitySelection}
                          value={selectedCity.value}
                        >
                          {cities.map((city) => (
                            <option key={city.value} value={city.value}>
                              {city.name} ({city.price} lei)
                            </option>
                          ))}
                        </select>
                        {deliveryDateValidationError && (
                          <div
                            className="error-message"
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {deliveryDateValidationError}
                          </div>
                        )}
                      </div>
                      {showRecipientAddress && (
                        <div className=" delivery delivery-address">
                          <input
                            type="text"
                            className={`delivery-input ${
                              formErrors.recipientAddress ? "error" : ""
                            }`}
                            placeholder="Stradă, număr"
                            name="address"
                            value={recipientData.address}
                            onChange={handleRecipientChange}
                            style={
                              formErrors.recipientAddress
                                ? styles.errorInput
                                : {}
                            }
                          />
                          <label className="delivery-label">
                            Stradă, număr
                          </label>
                          {formErrors.recipientAddress && (
                            <div className="error-message" style={styles.error}>
                              {formErrors.recipientAddress}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="no-delivery-address ">
                      <label className=" no-delivery-label check">
                        <input
                          type="checkbox"
                          className="hidden check"
                          checked={!showRecipientAddress}
                          onChange={() =>
                            setShowRecipientAddress(!showRecipientAddress)
                          }
                        />
                        Obțineți adresa de la destinatar
                      </label>
                    </div>
                    <div className="delivery delivery-message-box">
                      <textarea
                        className="delivery-input-message  delivery-input"
                        id="message"
                        rows="3"
                        placeholder="Dacă doriți să lăsați o notă pentru comandă, scrieți-o sau lăsați câmpul gol."
                      ></textarea>
                      <label
                        htmlFor="message"
                        className="delivery-label-message delivery-label"
                      >
                        Observații comandă
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {isPickupSelected && (
                <div className="same-address-image">
                  <img
                    src={pickupLocation}
                    alt="Pickup Location"
                    className="pickup-image"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="checkout-box">
            <div className="checkout-heading p-4">
              <span>2</span>
              <span>Cine expediaza comanda? (Expeditor)</span>
            </div>

            <div className="checkout-body">
              <div className="same-address">
                <label className="check">
                  <input
                    type="checkbox"
                    className="hidden check"
                    checked={euSuntDestinatarul}
                    disabled={isPickupSelected}
                    onChange={() => setEuSuntDestinatarul(!euSuntDestinatarul)}
                  />
                  Eu sunt destinatarul
                </label>
              </div>

              <div className="same-address-box space-y-4">
                {!euSuntDestinatarul && (
                  <div className="grid-col-checkout">
                    <div className="delivery delivery-name">
                      <input
                        type="text"
                        className={`delivery-input ${
                          formErrors.senderName ? "error" : ""
                        }`}
                        placeholder="Nume Prenume"
                        name="name"
                        value={senderData.name}
                        onChange={handleSenderChange}
                        style={formErrors.senderName ? styles.errorInput : {}}
                      />
                      <label className="delivery-label">Nume Prenume</label>
                      {formErrors.senderName && (
                        <div className="error-message" style={styles.error}>
                          {formErrors.senderName}
                        </div>
                      )}
                    </div>

                    <div className="delivery delivery-phone">
                      <input
                        type="tel"
                        className={`delivery-input ${
                          formErrors.senderPhone ? "error" : ""
                        }`}
                        name="phone"
                        placeholder="Telefon"
                        value={senderData.phone}
                        onChange={handleSenderChange}
                        style={formErrors.senderPhone ? styles.errorInput : {}}
                      />
                      <label className="delivery-label">Telefon</label>
                      {formErrors.senderPhone && (
                        <div className="error-message" style={styles.error}>
                          {formErrors.senderPhone}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="grid-col-checkout">
                  <div className="delivery delivery-email">
                    <input
                      type="email"
                      className={`delivery-input delivery-input-email ${
                        formErrors.senderEmail ? "error" : ""
                      }`}
                      placeholder="Email"
                      name="email"
                      value={senderData.email}
                      onChange={handleSenderChange}
                      style={formErrors.senderEmail ? styles.errorInput : {}}
                      required // Added 'required' attribute here
                    />
                    <label className="delivery-label">Email</label>
                    {formErrors.senderEmail && (
                      <div className="error-message" style={styles.error}>
                        {formErrors.senderEmail}
                      </div>
                    )}
                  </div>
                  {!euSuntDestinatarul && (
                    <div className="delivery delivery-address">
                      <input
                        type="text"
                        className={`delivery-input ${
                          formErrors.senderAddress ? "error" : ""
                        }`}
                        placeholder="Stradă, număr"
                        name="address"
                        value={senderData.address}
                        onChange={handleSenderChange}
                        style={
                          formErrors.senderAddress && !senderData.address.trim()
                            ? styles.errorInput
                            : {}
                        }
                      />
                      <label className="delivery-label">Stradă, număr</label>
                      {formErrors.senderAddress &&
                        !senderData.address.trim() && (
                          <div className="error-message" style={styles.error}>
                            {formErrors.senderAddress}
                          </div>
                        )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="checkout-box ">
            <div className="checkout-heading p-4">
              <span>3</span>
              <span>Metode de plată</span>
            </div>

            <div className="checkout-body">
              <div className="same-address ">
                <label className="check">
                  <input
                    type="checkbox"
                    className="hidden check"
                    checked={isCardSelected}
                    onChange={() => {
                      setIsCardSelected(!isCardSelected);
                    }}
                  />
                  Plată cu cardul
                </label>
              </div>

              {isCardSelected && (
                <div className="same-address-image">
                  <div className="payment-secure-info ">
                    <div className="">
                      <span className="text-gray-600">
                        Plata va fi procesată securizat prin PayNet
                      </span>
                    </div>
                    <p>Acceptăm toate cardurile de debit și credit</p>
                    <div className="accepted-cards">
                      <img
                        src={visa}
                        alt="Visa"
                        className=" card-img visaCard-checkout"
                      />
                      <img
                        src={masterCard}
                        alt="Mastercard"
                        className="card-img masterCard-checkout"
                      />
                      <img
                        src={paynet}
                        alt="Paynet"
                        className="card-img paynet"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className=" checkout-box-col-2">
          <div className="checkout-heading p-4">
            <span>4</span>
            <span>Detalii comanda</span>
          </div>
          <div className="checkout-sidebar">
            <div className="order_review">
              <table className="shop_table">
                <thead>
                  <tr>
                    <th className="product-name">Produs</th>
                    <th className="product-total">Sub-total</th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item, index) => (
                    <React.Fragment key={item.id || index}>
                      {/* Main Item */}
                      <tr className="cart_item">
                        <td className="product-name">
                          <p className="ts-product-image">
                            <img src={item.image} alt={item.name} />
                          </p>
                          <span>{item.name}</span>&nbsp;
                          <span className="product-quantity cantitate-absolut">
                            x {item.quantity}
                          </span>
                        </td>
                        <td className="product-total">
                          {item.originalPrice && (
                            <div>
                              <span className="woocommerce-Price-amount amount">
                                {item.originalPrice}
                                <span className="woocommerce-Price-currencySymbol">
                                  lei
                                </span>
                              </span>
                            </div>
                          )}
                          <span className="woocommerce-Price-amount amount">
                            <bdi>
                              {item.price}
                              <span className="woocommerce-Price-currencySymbol">
                                lei
                              </span>
                            </bdi>
                          </span>
                        </td>
                      </tr>

                      {/* Extra Items */}
                      {item.extras &&
                        item.extras.length > 0 &&
                        item.extras.map((extra) => (
                          <tr key={extra.id} className="cart_item cart-extra">
                            <td className="product-name">
                              <p className="ts-product-image">
                                <img src={extra.image} alt={extra.name} />
                              </p>
                              <span>{extra.name}</span>&nbsp;
                              <span className="product-quantity cantitate-absolut">
                                x 1
                              </span>
                            </td>
                            <td className="product-total">
                              <span className="woocommerce-Price-amount amount">
                                <bdi>
                                  {extra.price}
                                  <span className="woocommerce-Price-currencySymbol">
                                    lei
                                  </span>
                                </bdi>
                              </span>
                            </td>
                          </tr>
                        ))}

                      {item.greetingText && (
                        <tr className="cart_item greeting-text">
                          <strong>Text pentru felicitare: </strong>
                          <td colSpan="2" className="product-name">
                            <div className="greeting-section-box">
                              <p className="greeting-text-written">
                                {item.greetingText}
                              </p>
                            </div>
                          </td>
                        </tr>
                      )}

                      {(item.deliveryDate || item.deliveryTime) && (
                        <tr className="cart_item delivery-info">
                          <td colSpan="2" className="product-name">
                            <div className="delivery-details">
                              {item.deliveryDate && (
                                <p className="delivery-date">
                                  <strong> Data de livrare:</strong>{" "}
                                  {item.deliveryDate}
                                </p>
                              )}
                              {item.deliveryTime && (
                                <p className="delivery-time">
                                  <strong> Ora:</strong> {item.deliveryTime}
                                </p>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>

              <div className="cart-popup-divider-small"></div>
              <div className="checkout-summary">
                <div className="checkout-row">
                  <span className="left-align">Sub-total:</span>
                  <span className="right-align">{total} lei</span>
                </div>

                <div className="checkout-row">
                  <span className="left-align">Livrare:</span>
                  <span className="right-align">
                    {isPickupSelected ? (
                      <span>Ridicare de la sediu</span>
                    ) : isEligibleForFreeDelivery() ? (
                      <span className="free-shipping-checkout">
                        Livrare Gratuită
                      </span>
                    ) : (
                      <span>{selectedCity.price} lei</span>
                    )}
                  </span>
                </div>

                <div className="checkout-row total">
                  <span className="left-align">Total:</span>
                  <span className="right-align">
                    <strong>{calculateFinalTotal()} lei</strong>
                  </span>
                </div>
              </div>
              {!isPickupSelected && isEligibleForFreeDelivery() && (
                <div className="ux-free-shipping">
                  <div className="ux-free-shipping__notice ux-free-shipping__notice--success">
                    Comanda ta va fi livrată gratuit 🎉
                  </div>
                </div>
              )}
              <div className="ux-free-shipping__bar ux-free-shipping__bar--striped">
                <span
                  className="ux-free-shipping__bar-progress"
                  style={{ width: "100%" }}
                ></span>
              </div>

              <div id="payment" className="woocommerce-checkout-payment">
                <div className="form-row place-order">
                  <div className="woocommerce-terms-and-conditions-wrapper mb-half ">
                    <p className="form-row">
                      <label className="woocommerce-form__label checkbox">
                        <input
                          type="checkbox"
                          className="woocommerce-form__input input-checkbox"
                          checked={isAnonymous}
                          onChange={() => setIsAnonymous(!isAnonymous)}
                        />
                        <span>Doresc ca comanda să fie anonimă</span>
                      </label>
                    </p>

                    <p className="form-row validate-required">
                      <label className="woocommerce-form__label checkbox">
                        <input
                          type="checkbox"
                          className="woocommerce-form__input input-checkbox"
                          name="terms"
                          id="terms"
                          checked={isTermsChecked}
                          onChange={() => {
                            setIsTermsChecked(!isTermsChecked);
                            setShowTermsWarning(false);
                          }}
                        />
                        <span>
                          Am citit și sunt de acord cu{" "}
                          <Link
                            className="btn terms-link"
                            to="/termeni-si-conditii"
                          >
                            termeni și condiții
                          </Link>
                        </span>
                        &nbsp;<span className="required">*</span>
                      </label>
                      <input type="hidden" name="terms-field" value="1" />
                    </p>

                    {showTermsWarning && (
                      <p
                        className="error-message"
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "10px",
                        }}
                      >
                        Trebuie să acceptați termenii și condițiile înainte de a
                        continua!
                      </p>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-submit"
                    id="place_order"
                    onClick={handlePlaceOrder}
                    disabled={isProcessing || deliveryDateValidationError}
                  >
                    {isProcessing ? "Se procesează..." : "Plasează comanda"}
                  </button>
                  {isProcessing && (
                    <div className="overlay">
                      <div className="loading-animation">
                        <div className="spinner"></div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
